import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-type-selection',
  templateUrl: './document-type-selection.component.html',
  styleUrls: ['./document-type-selection.component.scss']
})
export class DocumentTypeSelectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
